import "./String.startsWith";
import "./String.includes";
import "./Element.closest";
import "./Nodelist.forEach";
import "./Object.assign";
